import ApiService from "../../api/api.service";
import { GET_BULLIONS_DATA, DELETE_BULLIONS_DATA , GET_BARS_COIN_FORM_DATA, GET_BULLION_TYPE_DATA, 
	GET_PRICE_OF_PURITY, SAVE_BULLIONS_DATA, GET_EDIT_BARS_COIN_FORM_DATA, GET_JEWELLERY_ADD_FORM_DATA,
	 GET_JEWELLERY_EDIT_FORM_DATA, GET_ADD_DIGITAL_GOLD_ADD_FORM_DATA, GET_EDIT_DIGITAL_GOLD_FORM_DATA, 
	 GET_SOVEREIGN_GOLD_BONDS_ADD_DATA, GET_GOLD_BOND_DATA, GET_SOVEREIGN_GOLD_BONDS_EDIT_DATA } from "../actions.type";

const getDefaultBullionState = () => {
	return {

		bullionsData: {},
		barsAndCoinAddFormData: {},
		bullionTypeData: {},
		priceOfPurity: {},
		barsAndCoinEditFormData: {},
		jewelleryAddFormData: {},
		jewelleryEditFormData: {},
		digitalGoldAddFormData: {},
		digitalEditGoldAddFormData: {},
		sovereignGoldBondsAddFormData: {},
		goldBondData: {},
		sovereignGoldBondsEditFormData: {},

	}
};

const state = getDefaultBullionState();

const getters = {

	getBullionsData (state) {
		return state.bullionsData;
	},

	getBarsAndCoinAddFormData (state) {
		return state.barsAndCoinAddFormData;
	},

	getBullionTypeData (state) {
		return state.bullionTypeData;
	},

	getPriceOfPurity (state) {
		return state.priceOfPurity;
	},

	getBarsAndCoinEditFormData (state) {
		return state.barsAndCoinEditFormData;
	},

	getJewelleryAddFormData (state) {
		return state.jewelleryAddFormData;
	},

	getJewelleryEditFormData (state) {
		return state.jewelleryEditFormData;
	},

	getDigitalGoldAddFormData (state) {
		return state.digitalGoldAddFormData;
	},

	getDigitalEditGoldAddFormData (state) {
		return state.digitalEditGoldAddFormData;
	},

	getSovereignGoldBondsAddFormData (state) {
		return state.sovereignGoldBondsAddFormData;
	},

	getGoldBondData (state) {
		return state.goldBondData;
	},

	getSovereignGoldBondsEditFormData (state) {
		return state.sovereignGoldBondsEditFormData;
	},


};

const mutations = {

	setBullionsData (state, data) {
		state.bullionsData = data
	},

	setBarsAndCoinAddFormData (state, data) {
		state.barsAndCoinAddFormData = data
	},

	setBullionTypeData (state, data) {
		state.bullionTypeData = data
	},

	setPriceOfPurity (state, data) {
		state.priceOfPurity = data
	},

	setBarsAndCoinEditFormData (state, data) {
		state.barsAndCoinEditFormData = data
	},

	setJewelleryAddFormData (state, data) {
		state.jewelleryAddFormData = data
	},

	setJewelleryEditFormData (state, data) {
		state.jewelleryEditFormData = data
	},

	setDigitalGoldAddFormData (state, data) {
		state.digitalGoldAddFormData = data
	},

	setDigitalEditGoldAddFormData (state, data) {
		state.digitalEditGoldAddFormData = data
	},

	setSovereignGoldBondsAddFormData (state, data) {
		state.sovereignGoldBondsAddFormData = data
	},

	setGoldBondData (state, data) {
		state.goldBondData = data
	},

	setSovereignGoldBondsEditFormData (state, data) {
		state.sovereignGoldBondsEditFormData = data
	},

};


const actions = {

	[GET_BULLIONS_DATA](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setBullionsData',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},

	[DELETE_BULLIONS_DATA](context, credentials) {

		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}

				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});

	},

	[GET_BARS_COIN_FORM_DATA](context, credentials) {

		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {

				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}

				context.commit('setBarsAndCoinAddFormData',data);

				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},

	[GET_BULLION_TYPE_DATA](context, credentials) {

		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {

				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}

				context.commit('setBullionTypeData',data);

				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},

	[GET_PRICE_OF_PURITY](context, credentials) {

		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {

				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}

				context.commit('setPriceOfPurity',data);

				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},

	[SAVE_BULLIONS_DATA](context, credentials) {

		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {

				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}

				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},

	[GET_EDIT_BARS_COIN_FORM_DATA](context, credentials) {

		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {

				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}

				context.commit('setBarsAndCoinEditFormData',data);

				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},

	[GET_JEWELLERY_ADD_FORM_DATA](context, credentials) {

		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {

				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}

				context.commit('setJewelleryAddFormData',data);

				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},

	[GET_JEWELLERY_EDIT_FORM_DATA](context, credentials) {

		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {

				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}

				context.commit('setJewelleryEditFormData',data);

				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},

	[GET_ADD_DIGITAL_GOLD_ADD_FORM_DATA](context, credentials) {

		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {

				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}

				context.commit('setDigitalGoldAddFormData',data);

				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},

	[GET_EDIT_DIGITAL_GOLD_FORM_DATA](context, credentials) {

		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {

				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}

				context.commit('setDigitalEditGoldAddFormData',data);

				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},

	[GET_SOVEREIGN_GOLD_BONDS_ADD_DATA](context, credentials) {

		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {

				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}

				context.commit('setSovereignGoldBondsAddFormData',data);

				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},

	[GET_GOLD_BOND_DATA](context, credentials) {

		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {

				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}

				context.commit('setGoldBondData',data);

				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},
	
	[GET_SOVEREIGN_GOLD_BONDS_EDIT_DATA](context, credentials) {

		return new Promise((resolve, reject) => {
			ApiService.setHeader();

			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {

				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}

				context.commit('setSovereignGoldBondsEditFormData',data);

				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			console.log(response,'post');
			if(response.logout == true)
			{

				window.location.replace('/');

			}
			console.log("Something went wrong");
		});
	},


};

export default {
	getters,
	actions,
	mutations,
	state
}